import { render, staticRenderFns } from "./ProfileSubModuleCards.vue?vue&type=template&id=a94afaee&scoped=true"
import script from "./ProfileSubModuleCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileSubModuleCards.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94afaee",
  null
  
)

export default component.exports